import script from "./BillingYearly.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingYearly.vue?vue&type=script&setup=true&lang=js"

import "./BillingYearly.vue?vue&type=style&index=0&id=8df8e9d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8df8e9d2"]])

export default __exports__